import { actionConst } from '../constants/add-orgs.constants';

const defaultState = {
	modalVisible: false,
	docId: undefined,	
	posted: false,
	updatedDocument: null,
	contractorId: undefined,
}

export default (state = defaultState, action = {}) => {
	switch (action.type) {
		case actionConst.RESET_POSTED_DOCUMENT: {
			return {
				...state,
				postDocumentID: null
			}
		}
		case actionConst.POST_DOCUMENT: {
			return {
				...state,
				postDocumentID: action.payload
			}
		}
		case actionConst.FETCH_DOCTYPE_REF + '_FULFILLED': {
			return {
				...state,
				listDocumentType: action.payload.data.data || action.payload.data
			}
		}
		case actionConst.FETCH_ORDTYPE_REF + '_FULFILLED': {
			return {
				...state,
				listOrdType: action.payload.data.data || action.payload.data
			}
		}
		case actionConst.FETCH_EXECUTER_REF + '_FULFILLED': {
			return {
				...state,
				listExecuter: action.payload.data.data || action.payload.data
			}
		}
		case actionConst.OPEN_MODAL: {
			return {
				...state,
				modalVisible: true,
				docId: action.payload,
				posted: false
			}
		}
		case actionConst.CLOSE_MODAL: {
			return {
				...state,
				modalVisible: false
			}
		}
		default:
			return state;
	}
}